module.exports = __webpack_public_path__ + "static/bg-a0e87d68c10d90b4096eba14425dfe87.mp4";